module.exports = __webpack_public_path__ + "static/media/pomegranate.405c1548.webp";